import { render, staticRenderFns } from "./KolonneSettingsVehiclesListItem.vue?vue&type=template&id=c0aa32f0"
import script from "./KolonneSettingsVehiclesListItem.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsVehiclesListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports